// src/layouts/MainLayout.tsx
import { Box, CssBaseline } from "@mui/material";
import Sidebar from "../components/navigation/SideNavigation";
import { Outlet } from "react-router-dom";
import { useMediaQuery, useTheme } from "@mui/material";

export default function MainLayout() {
  const theme = useTheme();

  // true if screen is below "sm" breakpoint (600px by default)
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box sx={{ display: "flex", gap: isMobile ? '0px' : '24px'  , width: '100%' }}>
      <CssBaseline />
      {/* <Header /> */}
      <Sidebar />
      <Box
        component="main"
        sx={{
          // flexGrow: 1,
          bgcolor: isMobile ? "background.paper" : "background.default",
          p: isMobile ? 0 : 3,
          pb: isMobile ? "72px" : 3,
          height: isMobile ? '100%' : 'calc(100vh - 36px)',
          width: '100%',
          // mt: 8, // space for header
        }}
      >
        {/* Render the current page (Dashboard, NetworkAnalysis, etc.) */}
        <Outlet />
      </Box>
    </Box>
  );
}
